import { render, staticRenderFns } from "./Swasta.vue?vue&type=template&id=30bf4e1c&"
import script from "./Swasta.vue?vue&type=script&lang=js&"
export * from "./Swasta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports